import React from 'react';
import {useStoreState} from 'easy-peasy';
import EventsListView from '@/views/events/EventsListView';

interface AgentEventsViewProps {
    agentId?: string;
}

const AgentEventsView: React.FC<AgentEventsViewProps> = React.memo(({agentId}) => {
    const activeStoryObject = useStoreState((state: any) => state.activeStoryObject.activeStoryObject);

    return (
        <>
            <EventsListView
                activeObject={agentId || activeStoryObject}
                activeObjectType="agent"
            />
        </>
    );
});

export default AgentEventsView;
